
<template>
    <div class="row header-row hcol-1">
        <div class="col-5 logo-col">
            <div class="logo-ct pl-5 py-2 pr-3">
                <img src="@/assets/img/wingo-logo-teal.svg" alt="">
            </div>
        </div>
        <div class="col-7 text-right misc-col py-2 pr-4">
            <!-- <a class="px-4 py-3 btn btn-link" href="#" @click="changeLanguage($event)"><span class="px-2 py-5"><span class="material-icons">language</span>{{language === "lv" ? 'English' : 'Latviski'}}</span></a> -->
            <div class="language-switch">
                <a :class="language === 'lv' ? 'active' : ''" href="#" @click="changeLanguage($event, 'lv')">Latviešu</a>
                <a :class="language === 'en' ? 'active' : ''" href="#" @click="changeLanguage($event, 'en')">English</a>
			</div>
        </div>
    </div>
</template>

<script>
export default {
  components: {
  },
  props: [
      "language"
  ],
  data () {
    return {
    }
  },
  mounted () {
  },
  created () {
  },
  computed: {
  },
  methods: {
      changeLanguage(event, buttonLang) {
          event.preventDefault();
          if (buttonLang !== this.language) {
            this.$emit('changeLanguage');
          }
      }
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
</style>